import React from 'react';

const ChartCard = ({ title, children }) => {
  return (
    <div className="chart-card"> {/* Use the card-base styles via CSS */}
      {title && <h3 className="chart-card__title">{title}</h3>}
      {/* Wrapper for chart canvas will be styled by chart-container-wrapper */}
      {children}
    </div>
  );
};

export default ChartCard;